import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { Inject } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';


// import { GlobalEventsManagerService } from '././../../../../services/global-events-manager.service';

import { TranslateService } from '@ngx-translate/core';
import { InternationalsFormats, LabelValue, MessageDisplay, ParamLabelsI18n, ParamOtherData, ParamPartsSuppliesModel,
          ParamRatesModel,
          ProfileTax, StockProduct, ToolApiResponse, ToolArgs,
          ToolKeyValue, WksBusinessModel, WksEntity, WksEntityImg, WksEntityParams } from 'src/app/models';
import { WorksService } from 'src/app/services/works.service';
import { SharingDataService } from 'src/app/services/sharing-data.service';

import { ModalCommonComponent } from 'src/app/components/common/modal-common/modal-common.component';
import { CommonMethods } from 'src/app/components/common/tools/commonMethods';
import { DateAdapter } from '@angular/material/core';
import { UserService } from 'src/app/services/user.service';
import { AuthService } from 'src/app/services/auth.service';
import { BarCode, BrandWksModel, MeasurementList } from 'src/app/models/works/wks-common.model';
import { GlobalEventsManagerService } from 'src/app/services/global-events-manager.service';

@Component({
  selector: 'app-suppliers-orders',
  templateUrl: './suppliers-orders.component.html',
  styleUrls: ['./suppliers-orders.component.less']
})
export class SuppliersOrdersComponent implements OnInit {

  @Input()
  wksEntityParams: WksEntityParams;
  @Input()
  wksEntity: WksEntity;
  @Input()
  countryFmt: any;

  private readonly onDestroy = new Subject<void>();

  doSearchByRef: boolean;
  doSearchByBarCode: boolean;
  okToSearch: boolean;
  displayCreateForm: boolean;
  okToCreate: boolean;
  okToDisplayMenu: boolean;

  btnQuit: boolean;

  MIN_CAR = 4;

  messageDialogRef: MatDialogRef<ModalCommonComponent>;
  listProducts: {
    paramPartsSupplies: ParamPartsSuppliesModel;
    stockId?: string;
    stockVirtual?: number;
    stockPhysical?: number;
    isCollapsed: boolean;
    isOkToValid: boolean;
  }[];
  displayListProducts: boolean;
  unitsQuantity: LabelValue[];

  profileTax: ProfileTax;
  numberFormat: {
    locale: string;
    minDecimal: string;
    maxDecimal: string;
    currency: string;
    justifCurrency: string;
    justifText: string;
    justifNumbers: string;
  };

  internationalsFormats: InternationalsFormats;
  dateFormat: string;
  dateFormatMoment: string;
  dateTimeFormat: string;
  localelang: string;
  localeDateFmt: string;
  entityCurrency: string;

  brandsList: BrandWksModel[];
  wareHousesList: {
    warehouseId: string;
    warehouseRef: string;
  }[];
  warehouseCur: string;

  partsRules: {
    partsLabelRegex: string;
    partsLabelMask: string;
    partsRefRegex: string;
    partsRefMask: string;
  };
  suppliersList: WksBusinessModel[];
  supplierCur: WksBusinessModel;

  barCodes: BarCode[];
  updateBarcodeStock: boolean;

  constructor(private globalEventsManagerService: GlobalEventsManagerService,
              private worksService: WorksService,
              private translateService: TranslateService,
              private sharingDataService: SharingDataService,
              private adapterDate: DateAdapter<any>,
              private authService: AuthService,
              private matDialog: MatDialog) { }

  ngOnInit(): void {
    this.initAllBooleans();
    this.settingIntFmts();
    this.initParams();
    this.initData();
    // this.loadWareHouses();
    // this.loadBrands();
    // this.loadSuppliers();

    this.loadBrands()
    .then ((response1: any) => {
      this.loadSuppliers()
      .then ((response2: any) => {
          this.loadWareHouses();
        })
      .catch ((error: any) => {
        console.log('loadSuppliers : ' + error);
        return;
      });
    })
    .catch ((error: any) => {
      console.log('loadBrands : ' + error);
      return;
    });
  }
  initData(): void {
    this.wareHousesList = [];
  }
  initAllBooleans(): void {
    this.doSearchByRef = false;
    this.doSearchByBarCode = false;
    this.okToSearch = false;
    this.displayListProducts = false;
    this.displayCreateForm = false;
    this.okToCreate = false;
    this.okToDisplayMenu = false;

    this.btnQuit = true;
    this.updateBarcodeStock = false;
  }
  settingIntFmts(): void {
    const otherData = JSON.parse(this.wksEntity.otherData);
    const internationnalFormat = otherData.internationnalFormat;
    this.internationalsFormats = this.sharingDataService.getIntFormat(internationnalFormat);
    for (const fmtCur of this.internationalsFormats.datetime) {
      if (fmtCur.name === 'dateFormat') {
        this.dateFormat = fmtCur.value;
        this.dateFormatMoment = fmtCur.value;
        this.dateFormatMoment = this.dateFormatMoment.replace('dd', 'DD');
        this.dateFormatMoment = this.dateFormatMoment.replace('yyyy', 'YYYY');
      }
      if (fmtCur.name === 'timeFormat') {
        this.dateTimeFormat = fmtCur.value;
        this.dateTimeFormat = this.dateTimeFormat.replace('dd', 'DD');
        this.dateTimeFormat = this.dateTimeFormat.replace('yyyy', 'YYYY');
      }
    }
    // this.adapterDate.setLocale(this.translate.currentLang);
    const userLang = navigator.language ;
    this.adapterDate.setLocale(userLang ? userLang : otherData.language + '_' + internationnalFormat);
    // this.localelang = userLang;
    this.localelang =  this.translateService.currentLang;
    this.localeDateFmt =  userLang ? userLang : otherData.language + '_' + internationnalFormat;
    const intFormat = otherData.internationnalFormat;
    this.numberFormat = {
      locale: this.sharingDataService.getFormat(intFormat, 'numbers', 'locale'),
      minDecimal: this.sharingDataService.getFormat(intFormat, 'numbers', 'minimumFractionDigits'),
      maxDecimal: this.sharingDataService.getFormat(intFormat, 'numbers', 'maximumFractionDigits'),
      currency:  this.sharingDataService.getFormat(intFormat, 'numbers', 'currency'),
      justifCurrency:  this.sharingDataService.getFormat(internationnalFormat, 'justifs', 'currency'),
      justifText:  this.sharingDataService.getFormat(internationnalFormat, 'justifs', 'text'),
      justifNumbers:  this.sharingDataService.getFormat(internationnalFormat, 'justifs', 'numbers')
    };
    const countryDef = this.sharingDataService.getCountry(this.wksEntity.entityCountry);
    const taxProfilesList = countryDef.taxation.profilesTax as ProfileTax[];
    const entityOptions = JSON.parse(this.wksEntity.entityOptions);
    const profileName = entityOptions.taxProfile;
    for (const taxProfileCur of taxProfilesList) {
      if (taxProfileCur.profileName === profileName) {
        this.profileTax = taxProfileCur;
        break;
      }
    }
    const partsRulesTmp = otherData.partsRules;
    if (partsRulesTmp !== undefined) {
          // /^[a-zA-Z0-9-\/]*$
          // [^a-zA-Z0-9-\/]

      this.partsRules =  {
        partsLabelRegex: partsRulesTmp.partsLabelRegex,
        partsLabelMask: partsRulesTmp.partsLabelMask,
        partsRefRegex: partsRulesTmp.partsRefRegex,
        partsRefMask: partsRulesTmp.partsRefMask,
      };
    }
    this.barCodes = this.sharingDataService.getBarCodes() as BarCode[];
    const barcodeAp: any[] = [];
    const barCodeBlank =  {
      code: '',
      comment: '',
      regex: '',
      API: barcodeAp
    };
    this.barCodes = [barCodeBlank, ...this.barCodes];
  }
  initParams(): void {
    const countryEntity  = this.sharingDataService.getCountry(this.wksEntity.entityCountry);
    const isMetric = (countryEntity.measurementUnit === 'METRIC');
    const jsonUnits = this.sharingDataService.getUnitsQuantity() as MeasurementList[];
    let measurementLocal = 'METRIC';
    if (!isMetric) {
      measurementLocal = 'NON_METRIC';
    }
    // tires
    this.unitsQuantity  = [];
    for (const measurLocal of jsonUnits) {
      if (measurLocal.measurement === measurementLocal) {
        const arrayUnits = [...measurLocal.list];
        for (const unitName of arrayUnits) {
          this.unitsQuantity.push({
            label: this.translateService.instant('COMMUN.UNITS.' + unitName),
            value: unitName
          });
        }
        break;
      }
    }
    const otherData = JSON.parse(this.wksEntity.otherData);
    const currencyCur = otherData.entityCurrency;
    this.entityCurrency = currencyCur;
    const entityOptions = JSON.parse(this.wksEntity.entityOptions);

  }
  loadBrands(): any {
    this.brandsList = [];

    return new Promise((resolve, reject) => {
      this.worksService.getWksBrandsList(this.authService.getUserLogged().entity)
      .pipe(takeUntil(this.onDestroy))
      .subscribe(
        data => {
          this.brandsList = data.body;

          this.brandsList.sort((obj1, obj2) => {
            return obj1.brandName > obj2.brandName ? 1 : -1;
          });
          resolve(this.brandsList);
        }, err => {
          // console.log(err);
          if (err.status === 404) {
            this.brandsList.push({
              stdEntity: this.authService.getUserLogged().entity,
              brandRow: 'brand',
              brandName: '',
              brandParam: undefined
            });
          }
          reject(err.status);
        }
      );
    });
  }
  // getWksSuppliersList(entity: string): Observable<HttpResponse<WksBusinessModel[]>>
  loadSuppliers(): any {
    this.suppliersList = [];

    return new Promise((resolve, reject) => {
      this.worksService.getWksSuppliersList(this.authService.getUserLogged().entity)
      .pipe(takeUntil(this.onDestroy))
      .subscribe(
        data => {
          this.suppliersList = data.body;

          this.suppliersList.sort((obj1, obj2) => {
            return obj1.bsnName > obj2.bsnName ? 1 : -1;
          });
          resolve(this.suppliersList);
        }, err => {
          // console.log(err);
          if (err.status === 404) {
            this.suppliersList.push({
              stdEntity: this.authService.getUserLogged().entity,
              bsnName: 'brand'
            });
          }
          reject(err.status);
        }
      );
    });
  }
  loadWareHouses(): void {
    const apiService = 'warehousesList';
    const apiName = 'stockManagement';
    const toolArgs: ToolArgs = {
      toolDatas: []
    };
    let testData = {
      key: 'toolCustomerNwsCode',
      value: this.sharingDataService.getApiStockManagement().toolCustomerNwsCode
    };
    toolArgs.toolDatas.push(testData);
    testData = {
      key: 'toolCustomerNwsId',
      value: this.sharingDataService.getApiStockManagement().toolCustomerNwsId
    };
    toolArgs.toolDatas.push(testData);

    this.worksService.requestApis(this.wksEntity.stdEntity, apiName, apiService, toolArgs )
    .subscribe(
      (data: any) => {

        const toolApiResponse = data.body as ToolApiResponse;
        if (toolApiResponse.statut === 'KO') {

        } else  {
          this.affectResponseWharehouses(toolApiResponse);
          this.okToDisplayMenu = true;
        }
      },
      err => {

      }
    );
  }
  affectResponseWharehouses(toolApiResponse: ToolApiResponse): void {

    for (const wareHouseItem of toolApiResponse.toolDatas[0].listValues) {
      const itemWareHouse = {
        warehouseId: wareHouseItem.nws_wharehouse_id,
        warehouseRef: wareHouseItem.nws_wharehouse_ref
      };
      this.wareHousesList.push(itemWareHouse);
    }
    this.warehouseCur = this.wareHousesList[0].warehouseId;
  }
  // warehousesList
  numberAndDotOnly(event: any): boolean {
    // console.log('numberAndDotOnly input ' + event);
    // console.log('numberAndDotOnly return ' + CommonMethods.numberAndDotOnly(event));
    return CommonMethods.numberAndDotOnly(event);
  }
  warehouseChoice(value: string): void {
    this.warehouseCur = value;
  }
  logout(): void  {
    this.globalEventsManagerService.synchroEvents.next('returnHome__suppliers_orders');
    return;
  }
}
